<script setup lang="ts">
import { ref, onMounted, provide } from 'vue'
import { useRoute } from 'vue-router'
import FormSection from '@/components/FormSection/index.vue'
import ResultSection from '@/components/ResultSection.vue'
import SwiftaidFooter from '@/components/SwiftaidFooter.vue'
import dataLayer from '@/components/dataLayerHelper'
import { mapQueryToDonorDetails } from '@/components/FormSection/urlParamsHelperDonorDetails'
import {
  reauthMode,
  hasEmailSignature,
} from '@/components/FormSection/urlParamsHelperReauth'
import type { UrlParamsDonorDetails, DonorDetails } from '@/types'

const route = useRoute()
const urlParamsDonorDetails = mapQueryToDonorDetails(
  route.query as UrlParamsDonorDetails<DonorDetails>
)
provide('urlParamsDonorDetails', urlParamsDonorDetails)

const isReauthMode: boolean = reauthMode(route.query)
provide('reauthMode', isReauthMode)

provide('hasEmailSignature', hasEmailSignature(route.query))

const showForm = ref(true)

const handleBackClick = () => {
  showForm.value = true
}

const handleFormSubmit = () => {
  showForm.value = false
}

onMounted(() => {
  if (isReauthMode) {
    window.document.title = 'Reauthorise Swiftaid | Swiftaid Donors'
  }

  // For testing purposes only
  if (route.query.test) {
    showForm.value = false
  }

  dataLayer.sendStartPageView()
})
</script>

<template>
  <div class="container pb-5">
    <form-section v-if="showForm" @submit="handleFormSubmit" />
    <result-section v-else @go-back="handleBackClick" />

    <swiftaid-footer />
  </div>
</template>
